// import { createContext, useContext, useState, useEffect } from 'react';
// import { startSilentRefresh } from './Components/Login/tokenManager';

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [loggedIn, setLoggedIn] = useState(null); // start null to indicate loading
//   const [userId, setUserId] = useState(null);
//   const [role, setRole] = useState(null);
//   const [roles, setRoles] = useState(null);

//   useEffect(() => {
//     const id = localStorage.getItem('user_id');
//     const storedRole = localStorage.getItem('user_role'); // fixed key here
//     const storedRoles = localStorage.getItem('user_roles');

//     if (id && storedRole && storedRoles) {
//       setLoggedIn(true);
//       setUserId(id);
//       setRole(storedRole);
//       setRoles(storedRoles);
//       startSilentRefresh(); 
//     } else {
//       setLoggedIn(false);
//     }
//   }, []);

//   const login = (id, userRole, userRoles) => {
//     localStorage.setItem('user_id', id);
//     localStorage.setItem('user_role', userRole);
//     localStorage.setItem('user_roles', userRoles);
//     setLoggedIn(true);
//     setUserId(id);
//     setRole(userRole);
//     setRoles(userRoles);
//   };

//   const logout = () => {
//     localStorage.clear();
//     setLoggedIn(false);
//     setUserId(null);
//     setRole(null);
//     setRoles(null);
//   };

//   return (
//     <AuthContext.Provider value={{ loggedIn, userId, role, roles, login, logout }}>
//       {loggedIn === null ? <div>Loading...</div> : children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);

import { createContext, useContext, useState, useEffect } from 'react';
import { startSilentRefresh, stopSilentRefresh } from './Components/Login/tokenManager';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(null); // null = loading
  const [userId, setUserId] = useState(null);
  const [role, setRole] = useState(null);
  const [roles, setRoles] = useState(null);

  useEffect(() => {
    const id = localStorage.getItem('user_id');
    const storedRole = localStorage.getItem('user_role');
    const storedRoles = localStorage.getItem('user_roles');
    const accessToken = localStorage.getItem('access_token');

    if (id && storedRole && accessToken) {
      setLoggedIn(true);
      setUserId(id);
      setRole(storedRole);
      setRoles(storedRoles);
      startSilentRefresh();
    } else {
      setLoggedIn(false);
    }
  }, []);

  const login = (id, userRole, userRoles) => {
    // Consistent storage keys
    localStorage.setItem('user_id', id);
    localStorage.setItem('user_role', userRole);
    localStorage.setItem('user_roles', userRoles);
    setLoggedIn(true);
    setUserId(id);
    setRole(userRole);
    setRoles(userRoles);
    startSilentRefresh();
  };

  const logout = () => {
    stopSilentRefresh();
    localStorage.clear();
    setLoggedIn(false);
    setUserId(null);
    setRole(null);
    setRoles(null);
  };

  return (
    <AuthContext.Provider value={{ loggedIn, userId, role, roles, login, logout }}>
      {loggedIn === null ? <div>Loading...</div> : children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);